import LinkRoute from './LinkRoute';

export default LinkRoute;
